import { isPureNum } from '@/utils'
import { getAddress, getHttpsAddress } from '@api/getBook.js'
const statistics = {
  data() {
    return {
      count: '',
      lock: true,
      startTime: '',
      outTime: 5, //5分钟
      readingLog: {},
      staticsTimer: null,
      address: '北京市'
    }
  },
  computed: {
    userName() {
      return localStorage.getItem('username')
    }
  },
  methods: {
    //判断是pc打开还是手机
    getOpenType() {
      if (navigator.userAgent.match(/(iPhone|iPod|Android|ios|iOS|iPad|Backerry|WebOS|Symbian|Windows Phone|Phone)/i)) {
        return 'mobile'
      } else {
        return 'pc'
      }
    },
    //判断操作系统
    getSystem() {
      var userAgent = navigator.userAgent.toLowerCase()
      var name = ''
      if (userAgent.indexOf('windows') > -1) {
        name = 'Windows'
      } else if (userAgent.indexOf('iphone') > -1) {
        name = 'Ios'
      } else if (userAgent.indexOf('macintosh') > -1) {
        name = 'Mac'
      } else if (userAgent.indexOf('android') > -1 || userAgent.indexOf('adr') > -1) {
        name = 'Android'
      } else {
        name = '其他'
      }
      return name
    },
    //判断是哪个浏览器
    getBrowser() {
      //qqbrowser 其他APP内嵌浏览器 360安全浏览器、360极速浏览器
      var UserAgent = navigator.userAgent.toLowerCase()
      //documentMode 是一个IE的私有属性，在IE8+中被支持。
      if (/micromessenger/.test(UserAgent)) {
        return '微信内嵌浏览器'
      }
      if (this.getOpenType() == 'mobile') {
        if (/alipayclient/.test(UserAgent)) {
          // AlipayClient
          return '其他APP内嵌浏览器'
        } else if (/qq/.test(UserAgent)) {
          // AlipayClient
          return '其他APP内嵌浏览器'
        }
      }
      if (window.document.documentMode) {
        return 'IE'
      }
      if (/firefox/.test(UserAgent)) return 'FireFox'
      if (/opera/.test(UserAgent)) return 'Opera'
      if (/safari/.test(UserAgent)) return 'Safari'
      // if ((/chrome/.test(UserAgent) && _mime('type', 'application/vnd.chromium.remoting-viewer')) || /gecko/.test(UserAgent)) return '360浏览器'
      if (/360ee/.test(UserAgent)) return '360极速浏览器'
      if (/360se/.test(UserAgent)) return '360安全浏览器'
      if (/metasr/.test(UserAgent)) return '搜狗浏览器'
      if (/qqbrowser/.test(UserAgent) || /tencenttraveler/.test(UserAgent)) return 'QQ浏览器'
      if (/chrome/.test(UserAgent)) return 'Chrome'
      return '其他'
    },
    //上传统计页面时长函数
    getStayTime(params) {
      if (!params) return
      var endTime = new Date()
      let total_time = endTime.getTime() - this.startTime.getTime()
      total_time = Math.ceil(Number(total_time) / 1000)
      var image = new Image()
      var browser = this.getBrowser()
      var openType = this.getOpenType()
      var system = this.getSystem()
      const decryption_id = isPureNum(this.$route.query.id)
      const it = this.$route.path.indexOf('paper') > -1 ? 'epaper' : 'ebook'
      image.src =
        window.PROJECT_CONFIG.BASE_URL2 +
        '/stat/log?it=' +
        it +
        '&ii=' +
        decryption_id +
        '&uid=&br=' +
        browser +
        '&ar=' +
        this.address +
        '&cl=' +
        openType +
        '&be=read&os=' +
        system +
        '&dur=' +
        total_time
      $('body').append(image)
      image.style.display = 'none'
    },
    showLocation(location) {
      console.log(location)
      this.address = location.city
    },
    locateError() {
      console.log('error:定位失败')
      this.address = '北京市'
    },
    goTime() {
      this.count++
      if (this.count == this.outTime * 60) {
        this.getStayTime(this.lock)
        this.lock = false
        clearInterval(this.staticsTimer)
      }
    }
  },
  created() {
    this.startTime = new Date()
    // this.getIpLocation() 与book.vue中重复调用暂不调用
  },
  mounted() {
    if (this.isStaticBook) {
      return
    }
    if (this.getOpenType() === 'pc') {
      window.addEventListener('unload', () => this.getStayTime(this.lock))
    } else if (this.getOpenType() === 'mobile') {
      window.addEventListener('pagehide', () => this.getStayTime(this.lock))
    }
    this.staticsTimer = window.setInterval(this.goTime, 1000)
    var x
    var y
    //监听鼠标
    document.onmousemove = function(event) {
      var x1 = event.clientX
      var y1 = event.clientY
      if (x != x1 || y != y1) {
        this.count = 0
      }
      x = x1
      y = y1
    }
    //监听键盘
    document.onkeydown = function() {
      this.count = 0
    }
    //监听手指
    document.addEventListener(
      'touchstart',
      function(e) {
        this.count = 0
      },
      false
    )
  },
  destroyed() {
    if (this.getOpenType() === 'pc') {
      window.removeEventListener('unload', () => this.getStayTime(this.lock))
    } else if (this.getOpenType() === 'mobile') {
      window.removeEventListener('pagehide', () => this.getStayTime(this.lock))
    }
  }
}

export default statistics
